import {
    IListaProdutos,
    IListaProdutosInteresseRequest,
    IProduto,
} from "../../../Interfaces/Vendas/Produtos/ProdutosInterfaces";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function ListarProdutosInteresseVendasService(idCaso: number) {
    return Service(
        AxiosVendas.post<Array<IListaProdutosInteresseRequest>>(
            `/app/produto/listarprodutosinteresse?idCaso=${idCaso}`
        )
    );
}

export async function ListarProdutosVendasService() {
    return Service(
        AxiosVendas.get<Array<IListaProdutos>>(`/app/produto/listarprodutos`)
    );
}

export async function ProdutoVendasService(requestBody: IProduto) {
    return Service(AxiosVendas.post(`/app/produto`, requestBody));
}

export async function TabelaPrecosProdutoVendasService(ID_PRODUTO: number) {
    return Service(
        AxiosVendas.post<string>(
            `/app/produto/tabeladeprecos?ID_PRODUTO=${ID_PRODUTO}`
        )
    );
}
